/* Sporbarhet: linjene i sertifikatregisteret og leverandørpunktene kommer
 * inn etter tur. Med «reduser bevegelse» står alt på plass fra start. */

import gsap from 'gsap';
import { $, mindreBevegelse } from '../kjerne/verktoy.js';

export function startSporbarhet() {
  if (!$('.sertifikater') || mindreBevegelse.matches) return;

  gsap.from('.sertifikat', {
    y: 24, opacity: 0, stagger: .07, duration: 1, ease: 'expo.out',
    scrollTrigger: { trigger: '.sertifikater', start: 'top 85%' },
  });
  gsap.from('.leverandorer > *', {
    y: 30, opacity: 0, stagger: .1, duration: 1, ease: 'expo.out',
    scrollTrigger: { trigger: '.leverandorer', start: 'top 88%' },
  });
}
